import { render, staticRenderFns } from "./SubscribePromoReady.vue?vue&type=template&id=38170ca8&scoped=true&"
import script from "./SubscribePromoReady.vue?vue&type=script&lang=js&"
export * from "./SubscribePromoReady.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePromoReady.vue?vue&type=style&index=0&id=38170ca8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38170ca8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribePromoButton: require('/opt/render/project/src/channels2022/src/components/subscribe-promo/SubscribePromoButton.vue').default})
